import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  backdrop: {
    zIndex: 10000
  },
  loadingIconClearWrapper: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    marginTop: '-12px',
    marginLeft: '-100px',
    zIndex: 2
  }
}));
